/* eslint-disable linebreak-style */
import { Injectable } from '@angular/core';
import { OnboardingFlowService } from '../onboarding-flow';
import { ComponentRoutesEnum } from '@shared/utils/component-routes';
import { EncryptionService } from '../encryption-service/encryption.service';
import { plainToClass } from 'class-transformer';
import { Login } from '@shared/models/login.model';
import { ErrorHandlerService } from '../error-handler/error-handler.service';

@Injectable({ providedIn: 'root' })
export class NavigationService {
	constructor(
		private onboardingFlowService: OnboardingFlowService,
		private encryptionService: EncryptionService,
		private errorHandlerService: ErrorHandlerService
	) {}

	initializeEventListeners() {
		window.addEventListener('navigate', this.handleNavigationEvent);
	}

	cleanupEventListeners() {
		window.removeEventListener('navigate', this.handleNavigationEvent);
	}

	private handleNavigationEvent = (event: Event) => {
		const customEvent = event as CustomEvent;
		if (customEvent.detail?.route) {
			if (
				customEvent.detail.route ===
				'/'.concat(ComponentRoutesEnum.MAX_ACCOUNTS_ERROR)
			) {
				this.errorHandlerService.goToErrorPage(
					ComponentRoutesEnum.MAX_ACCOUNTS_ERROR
				);
				return;
			} else {
				const loginResponse =
					this.encryptionService.getSessionStorage('userInfo');
				const username = this.encryptionService
					.getSessionStorage('username')
					?.replace(/['"]+/g, '');
				if (!loginResponse || !username) {
					this.errorHandlerService.genericError();
					return;
				}
				try {
					const userInfoJson = JSON.parse(loginResponse);
					const loginInstance = plainToClass(Login, userInfoJson);
					//Since this is coming from the ObLogin at this point the Enum is undefined so using 'QC' instead
					if (loginInstance.data.customerDetails.province === 'QC') {
						this.errorHandlerService.quebecRestriction();
						return;
					}
					this.onboardingFlowService.setContext(loginInstance, username);
				} catch (e) {
					this.errorHandlerService.genericError();
				}
			}
		}
	};
}
